<template>
  <v-layout row justify-center>
    <v-dialog v-model="this.open" persistent>
      <v-card>
        <v-card-title class="headline">Gebruiker Toevoegen</v-card-title>
                <v-card-text>
                <v-text-field v-model='email' label="Email" required></v-text-field>
                <v-text-field v-model='name' label="Naam" required></v-text-field>
                <v-text-field v-model='phone' label="Telefoon" required></v-text-field>
                <v-text-field v-model='password' label="Password" type="password" required></v-text-field>
            </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="closeModal">Cancel</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
    name: 'AddFoxModal',
    data () {
        return {
            email: '',
            name: '',
            phone: '',
            password: ''
        }
    },
    props: ['open', 'close'],
    methods: {
        save() {
            this.$store.dispatch('REGISTER_USER', {
                email: this.email,
                name: this.name,
                phone: this.phone,
                password: this.password,
                role: 10
            }).then(() => {
                this.email = '';
                this.name = '';
                this.phone = '';
                this.password = '';
                this.close();
            });
        },
        closeModal() {
            this.email = '';
            this.name = '';
            this.phone = '';
            this.password = '';
            this.close();
        }
    }
}


</script>




// WEBPACK FOOTER //
// src/components/AddUserModal.vue